module.exports = __webpack_public_path__ + "img/D202304_5.96ca07db.jpg";